import { Mail, ExternalLink, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <>
      <section className="px-4 pt-24 pb-16">
        <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-[1.1fr,0.9fr]">
          <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
            <h1 className="text-4xl font-bold leading-tight text-white sm:text-5xl md:text-6xl">
              Hi! I'm Andrew.
            </h1>
            <p className="mt-6 text-lg text-slate-300">
              I’m Andrew Barber, an AI and data enthusiast who loves taking ideas from notebook sketches to polished
              tools. From gesture-controlled games to developer utilities, I like to explore how code, design, and curiosity converge.
            </p>
            <div className="mt-8 flex w-full flex-wrap justify-center gap-3 lg:justify-start">
              <a
                className="inline-flex items-center gap-2 rounded-full bg-brand px-6 py-3 text-sm font-semibold text-white shadow-glow transition hover:-translate-y-0.5"
                href="mailto:arjbarber@gmail.com"
              >
                <Mail size={18} /> Start a conversation
              </a>
              <a
                className="inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 text-sm font-semibold text-white transition hover:border-brand"
                href="https://www.linkedin.com/in/andrewbarber08/"
                target="_blank"
                rel="noreferrer"
              >
                <Linkedin size={18} /> LinkedIn
              </a>
              <Link
                className="inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 text-sm font-semibold text-white transition hover:border-brand"
                to="/projects"
              >
                <ExternalLink size={18} /> Explore projects
              </Link>
            </div>
          </div>
          <div className="relative mx-auto flex w-full max-w-sm justify-center lg:justify-end">
            <div className="relative w-full max-w-xs overflow-hidden rounded-[2rem] border border-white/10 bg-white/5 shadow-2xl">
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
              <img
                className="h-full w-full object-cover"
                src="/Barber_Andrew.jpg"
                alt="Andrew Barber professional portrait"
              />
            </div>
            <div className="absolute -bottom-6 -left-4 hidden h-24 w-24 rounded-full border border-white/20 bg-brand/40 blur-3xl lg:block" />
            <div className="absolute -top-6 -right-10 hidden h-16 w-16 rounded-full border border-white/20 bg-sky-400/40 blur-3xl lg:block" />
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
